/*
 * Copyright 2022-2026 NXGN Management, LLC. All Rights Reserved.
 */

import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SearchComponent } from "./components/search/search.component";
import { LoginComponent } from "./components/security/login/login.component";
import { AuthGuardService, LoginGuardService } from "./services";
import { MerchantDetailsParentComponent } from "./components/merchant-details/merchant-details-parent.component";
import { CreateMerchantComponent } from "./components/merchant-details/create-merchant/create-merchant.component";
import { InitiateApplicationComponent } from "./components/onboarding/initiate-application/initiate-application.component";

const routes: Routes = [
  { path: "user/login", component: LoginComponent, canActivate: [LoginGuardService] },
  {
    path: "",
    canActivate: [AuthGuardService],
    children: [
      {
        path: "",
        redirectTo: "/merchants",
        pathMatch: "full"
      },
      {
        path: "merchants",
        children: [
          {
            path: "",
            component: SearchComponent
          },
          {
            path: "add",
            component: CreateMerchantComponent
          },
          {
            path: ":merchantId",
            component: MerchantDetailsParentComponent
          }
        ]
      },
      { path: "onboarding/initiate", component: InitiateApplicationComponent },
      { path: "home", component: SearchComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
